export const environment = {
  title: 'Absa Application',
  env_name: 'dev',
  debug: true,
  production: false,
  url: 'https://dev.api.smartfunder.co.za/',
  recaptcha: {
    siteKey: '6LdUzkEsAAAAAH4sY8D8w2ToIsNCJBBvDueEgO3i',
  },
};
